import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-hot-toast";
import * as Yup from "yup";
import axios from "axios";
import { FocusError } from "focus-formik-error";
import { useDispatch, useSelector } from "react-redux";
import {
  getCityData,
  getCountryData,
  getStateData,
} from "../../../../Redux/action/MasterAction";
import "react-phone-number-input/style.css";
import PhoneInput, {
  parsePhoneNumber,
  getCountryCallingCode,
} from "react-phone-number-input";
import Select from "react-select";
import HourglassLoader from "../../../../Common/HourglassLoader";
import ReCAPTCHA from "react-google-recaptcha";

const host = process.env.REACT_APP_API_SERVER;
const siteKey = process.env.REACT_APP_SITE_KEY;
const StudentRegister = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaError, setCaptchaError] = useState("");
  const captchaRef = React.useRef(null);

  const [faIcon, setfaIcon] = useState("fa-eye-slash");
  const togglePasswordType = () => {
    let input_pass = document.getElementById("password-field");
    const toggle_pass = document.getElementById("toggle_pass");
    let input_type = input_pass.getAttribute("type");
    if (input_type == "password") {
      setfaIcon("fa-eye");
      input_pass.type = "text";
    } else {
      setfaIcon("fa-eye-slash");
      input_pass.type = "password";
    }
  };
  const [faIcon1, setfaIcon1] = useState("fa-eye-slash");
  const togglePasswordType1 = () => {
    let input_pass = document.getElementById("password-field_1");
    const toggle_pass = document.getElementById("toggle_pass_1");
    let input_type = input_pass.getAttribute("type");
    if (input_type == "password") {
      setfaIcon1("fa-eye");
      input_pass.type = "text";
    } else {
      setfaIcon1("fa-eye-slash");
      input_pass.type = "password";
    }
  };

  useEffect(() => {
    dispatch(getCountryData());
  }, []);

  const {
    //country
    loadingCountryDataListApi,
    CountryDataListApiData,
    CountryDataListApiError,

    //state
    loadingStateDataListApi,
    StateDataListApiData,
    StateDataListApiError,

    //city
    loadingCityDataListApi,
    CityDataListApiData,
    CityDataListApiError,
  } = useSelector((state) => state?.MasterReducer);
  console.log("CountryDataListApiData", CountryDataListApiData);
  let [initialValues, setInitialValues] = useState({
    firstName: "",
    lastName: "",
    country_code: "",
    mobile: "",
    email: "",
    dob: "",
    gender: "",
    password: "",
    cpassword: "",
    about_the_tutor: "",
    country_id: "",
    state_id: "",
    city_id: "",
    address_line_1: "",
    address_line_2: "",
    zip_code: "",
  });

  const tutorformik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object().shape({
      firstName: Yup.string()
        .required("First name is required")
        .matches(/^[a-zA-Z .]+$/, "Name can only contain letters."),
      email: Yup.string()
        .required("Email is required.")
        .matches(
          /^\w+[-\.\w]*@(?!(?:)\.com$)\w+[-\.\w]*?\.\w{2,4}$/,
          "Enter a valid E-mail"
        ),
      mobile: Yup.string()
        .required("Phone number is required")
        .matches(/^[1-9][0-9]{7,14}$/, "Please enter a valid Mobile Number."),
      country_code: Yup.string().required("Country Code is required"),
      password: Yup.string()
        .required("Password is required")
        .min(6, "Password must be at least 6 characters long"),
      cpassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm password is required"),
       country_id: Yup.string().required("Country is required"),

  state_id: Yup.string().required("State is required"),

  city_id: Yup.string().required("City is required"),
       dob: Yup.string().required("Date of birth is required"),

      gender: Yup.string().required("Gender is required"),

  address_line_1: Yup.string().required("Address Line 1 is required"),
      // address_line_2: Yup.string().required("Address line 2 is required"),
      zip_code: Yup.string(),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {
      try {
        if (!captchaToken) {
          setCaptchaError("Please complete the CAPTCHA.");
           setSubmitting(false);
          return;
        }
        setSubmitting(true);
        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        const [country, phoneCode] = values.country_code.split("_");
        const formData = new FormData();
        formData.append("name", `${values.firstName} ${values.lastName}`);
        formData.append("email", values.email);
        formData.append("country_code", phoneCode);
        formData.append("mobile", values.mobile);
        formData.append("dob", values.dob);
        formData.append("gender", values.gender);
        formData.append("password", values.password);
        formData.append("about_the_tutor", values.about_the_tutor);
        formData.append("country_id", values.country_id);
        formData.append("state_id", values.state_id);
        formData.append("city_id", values.city_id);
        formData.append("address_line_1", values.address_line_1);
        formData.append("address_line_2", values.address_line_2);
        formData.append("zip_code", values.zip_code);
        formData.append("captchaToken", captchaToken);

        axios
          .post(`${host}/api/web/student-register`, formData, config)

          .then((res) => {
            if (res.status == 200) {
              toast.success(res.data.message);
              setSubmitting(false);
              navigate("/login", { state: { user: "student" } });
            } else {
              if (captchaRef.current) {
                captchaRef.current.reset(); // Reset the CAPTCHA
              }
              setCaptchaToken(null);
              toast.error(res.data.message);
              setSubmitting(false);
            }
          })
          .catch((err) => {
            if (captchaRef.current) {
              captchaRef.current.reset(); // Reset the CAPTCHA
            }
            setCaptchaToken(null);
            if (err.response) {
              toast.error(err.response.data.message);
            } else {
              toast.error("Internal server error.");
            }
            setSubmitting(false);
          });
      } catch (error) {
        if (captchaRef.current) {
          captchaRef.current.reset(); // Reset the CAPTCHA
        }
        setCaptchaToken(null);
        // console.log(error);
        toast.error(error.response.data.message);
        setSubmitting(false);
      }
    },
  });

  const handleCountryChange = (e) => {
    const id = e.target.value;
    tutorformik.setFieldValue("state_id", "");
    tutorformik.setFieldValue("city_id", "");

    if (id == "") {
      dispatch(getStateData("0"));
    } else {
      dispatch(getStateData(id));
    }
    dispatch(getCityData(0));
  };

  const handleStateChange = (e) => {
    const id = e.target.value;
    tutorformik.setFieldValue("city_id", "");
    if (id == "") {
      dispatch(getCityData("0"));
    } else {
      dispatch(getCityData(id));
    }
  };

  const handleCaptcha = (token) => {
    setCaptchaToken(token);
    setCaptchaError("");
  };

  return (
    <div className="form-body ">
      <form onSubmit={tutorformik.handleSubmit} method="post">
        <div className="row mb-3 p-5">
          <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
            <label htmlFor="first_name" className="form-label">
              First Name<span className="text-danger">*</span>
            </label>
            <input
              maxLength={20}
              type="text"
              className="input-form"
              id="first_name"
              placeholder="Enter your full name"
              name="firstName"
              onChange={tutorformik.handleChange}
              onBlur={tutorformik.handleBlur}
              value={tutorformik.values.firstName}
            />
            <div className="help-block with-errors">
              {tutorformik.touched.firstName && tutorformik.errors.firstName ? (
                <div className="text-danger">
                  {tutorformik.errors.firstName}
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Last Name
            </label>
            <input
              maxLength={20}
              type="text"
              className="input-form"
              id="exampleFormControlInput1"
              placeholder="Enter your last name"
              name="lastName"
              onChange={tutorformik.handleChange}
              onBlur={tutorformik.handleBlur}
              value={tutorformik.values.lastName}
            />
            <div className="help-block with-errors">
              {tutorformik.touched.lastName && tutorformik.errors.lastName ? (
                <div className="text-danger">{tutorformik.errors.lastName}</div>
              ) : null}
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
            <label htmlFor="mobile">
              Phone Number<span className="text-danger">*</span>
            </label>
            <div className="row">
              <div className="col-md-5">
                <select
                  className="form-select"
                  name="country_code"
                  onChange={(e) => {
                    tutorformik.handleChange(e);
                  }}
                  onBlur={tutorformik.handleBlur}
                  value={tutorformik.values.country_code}
                >
                  <option value="">--Select--</option>
                  {CountryDataListApiData?.map((data) => (
                    <option
                      key={data.sort_name}
                      value={`${data.sort_name}_${data.phone_code}`}
                    >
                      {data?.sort_name} ({data?.phone_code})
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-7">
                <input
                  maxLength={12}
                  type="text"
                  className="input-form"
                  id="exampleFormControlInput1"
                  placeholder="Enter your phone number"
                  name="mobile"
                  onChange={tutorformik.handleChange}
                  onBlur={tutorformik.handleBlur}
                  value={tutorformik.values.mobile}
                />
              </div>
            </div>
            {/* <PhoneInput
                            limitMaxLength={10}
                            id="mobile"
                            className="input-form"
                            placeholder="Enter your phone number"
                            defaultCountry="IN"
                            name="mobile"
                            value={tutorformik.values.mobile} // Bind tutorformik's value to PhoneInput
                            onChange={(value) => tutorformik.setFieldValue('mobile', value)} // Update tutorformik's value
                        /> */}
            <div className="help-block with-errors">
              {tutorformik.touched.mobile && tutorformik.errors.mobile ? (
                <div className="text-danger">{tutorformik.errors.mobile}</div>
              ) : null}
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Email ID<span className="text-danger">*</span>
            </label>
            <input
              maxLength={100}
              type="email"
              autoComplete="off"
              className="input-form"
              id="exampleFormControlInput1"
              placeholder="Enter your email Id"
              name="email"
              onChange={tutorformik.handleChange}
              onBlur={tutorformik.handleBlur}
              value={tutorformik.values.email}
            />
            <div className="help-block with-errors">
              {tutorformik.touched.email && tutorformik.errors.email ? (
                <div className="text-danger">{tutorformik.errors.email}</div>
              ) : null}
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Date of birth <span className="text-danger">*</span>
            </label>
            <input
              type="date"
              className="input-form"
              id="exampleFormControlInput1"
              placeholder="Enter your dob"
              name="dob"
              onChange={tutorformik.handleChange}
              onBlur={tutorformik.handleBlur}
              value={tutorformik.values.dob}
              max={new Date().toISOString().split("T")[0]}
              // onKeyDown={(e) => e.preventDefault()}
            />
            <div className="help-block with-errors">
              {tutorformik.touched.dob && tutorformik.errors.dob ? (
                <div className="text-danger">{tutorformik.errors.dob}</div>
              ) : null}
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Gender<span className="text-danger">*</span>
            </label>
            <select
              name="gender"
              id="gender"
              onChange={tutorformik.handleChange}
              onBlur={tutorformik.handleBlur}
              value={tutorformik.values.gender}
            >
              <option value="">-Select-</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
            <div className="help-block with-errors">
              {tutorformik.touched.gender && tutorformik.errors.gender ? (
                <div className="text-danger">{tutorformik.errors.gender}</div>
              ) : null}
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12">
            <div>
              <label htmlFor="inputPass" className="form-label">
                Password<span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <input
                  maxLength={10}
                  placeholder="Enter Your Password"
                  id="password-field"
                  type="password"
                  className="input-form"
                  name="password"
                  onChange={tutorformik.handleChange}
                  onBlur={tutorformik.handleBlur}
                  value={tutorformik.values.password}
                />
                <i
                  toggle="#password-field"
                  className={`fa-regular ${faIcon} field-icon toggle-password `}
                  id="toggle_pass"
                  onClick={togglePasswordType}
                />
              </div>
              <div className="help-block with-errors">
                {tutorformik.touched.password && tutorformik.errors.password ? (
                  <div className="text-danger">
                    {tutorformik.errors.password}
                  </div>
                ) : null}
              </div>
              {/* <span id="confirm-password-message" class="error-message"></span><br> */}
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div>
              <label htmlFor="vendorPassword" className="form-label">
                Confirm Password<span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <input
                  maxLength={10}
                  placeholder="Confirm Password"
                  id="password-field_1"
                  type="password"
                  className="input-form"
                  name="cpassword"
                  onChange={tutorformik.handleChange}
                  onBlur={tutorformik.handleBlur}
                  value={tutorformik.values.cpassword}
                />
                <i
                  toggle="#password-field_1"
                  className={`fa-regular ${faIcon1} field-icon toggle-password `}
                  id="toggle_pass"
                  onClick={togglePasswordType1}
                />
              </div>
              <div className="help-block with-errors">
                {tutorformik.touched.cpassword &&
                tutorformik.errors.cpassword ? (
                  <div className="text-danger">
                    {tutorformik.errors.cpassword}
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Address Line-1<span className="text-danger">*</span>
            </label>
            <input
              maxLength={100}
              type="text"
              className="input-form"
              id="exampleFormControlInput1"
              placeholder="Enter your address line-1"
              name="address_line_1"
              onChange={tutorformik.handleChange}
              onBlur={tutorformik.handleBlur}
              value={tutorformik.values.address_line_1}
            />
            <div className="help-block with-errors">
              {tutorformik.touched.address_line_1 &&
              tutorformik.errors.address_line_1 ? (
                <div className="text-danger">
                  {tutorformik.errors.address_line_1}
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Address Line-2
            </label>
            <input
              maxLength={100}
              type="text"
              className="input-form"
              id="exampleFormControlInput1"
              placeholder="Enter your address line-2"
              name="address_line_2"
              onChange={tutorformik.handleChange}
              onBlur={tutorformik.handleBlur}
              value={tutorformik.values.address_line_2}
            />
            <div className="help-block with-errors">
              {tutorformik.touched.address_line_2 &&
              tutorformik.errors.address_line_2 ? (
                <div className="text-danger">
                  {tutorformik.errors.address_line_2}
                </div>
              ) : null}
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Country <span className="text-danger">*</span>
            </label>
            <select
              name="country_id"
              onChange={(e) => {
                tutorformik.handleChange(e);
                handleCountryChange(e);
              }}
              onBlur={tutorformik.handleBlur}
              value={tutorformik.values.country_id}
            >
              <option value=""> --Select Country--</option>
              {CountryDataListApiData?.map((data) => (
                <option value={data?.id}>{data?.name}</option>
              ))}
            </select>
            <div className="help-block with-errors">
              {tutorformik.touched.country_id &&
              tutorformik.errors.country_id ? (
                <div className="text-danger">
                  {tutorformik.errors.country_id}
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              State<span className="text-danger">*</span>
            </label>
            <select
              name="state_id"
              onChange={(e) => {
                tutorformik.handleChange(e);
                handleStateChange(e);
              }}
              onBlur={tutorformik.handleBlur}
              value={tutorformik.values.state_id}
            >
              <option selected="" disabled="" value="">
                --Select State--
              </option>
              {StateDataListApiData?.map((data) => (
                <option value={data?.id}>{data?.name}</option>
              ))}
            </select>
            <div className="help-block with-errors">
              {tutorformik.touched.state_id && tutorformik.errors.state_id ? (
                <div className="text-danger">{tutorformik.errors.state_id}</div>
              ) : null}
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <label htmlFor="exampleFormControlInput1">City<span className="text-danger">*</span></label>
            <select
              name="city_id"
              id="city"
              onChange={tutorformik.handleChange}
              onBlur={tutorformik.handleBlur}
              value={tutorformik.values.city_id}
            >
              <option selected="" disabled="" value="">
                --Select City--
              </option>
              {CityDataListApiData?.map((data) => (
                <option value={data?.id}>{data?.name}</option>
              ))}
            </select>
            <div className="help-block with-errors">
              {tutorformik.touched.city_id && tutorformik.errors.city_id ? (
                <div className="text-danger">{tutorformik.errors.city_id}</div>
              ) : null}
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
            <label htmlFor="student_zip_code" className="form-label">
              Zip code
            </label>
            <input
              type="text"
              className="input-form"
              id="student_zip_code"
              placeholder="Enter your zip code"
              name="zip_code"
              onChange={tutorformik.handleChange}
              onBlur={tutorformik.handleBlur}
              value={tutorformik.values.zip_code}
              maxLength={6}
              minLength={4}
            />
            <div className="help-block with-errors">
              {tutorformik.touched.zip_code && tutorformik.errors.zip_code ? (
                <div className="text-danger">{tutorformik.errors.zip_code}</div>
              ) : null}
            </div>
          </div>

          <div className="col-lg-12 col-md-12 col-sm-12">
            <ReCAPTCHA
              sitekey={siteKey}
              onChange={handleCaptcha}
              ref={captchaRef} // Attach the ref to the CAPTCHA
            />
            {captchaError && <div className="text-danger">{captchaError}</div>}
          </div>
        </div>
        {/* <span id="confirm-password-message" class="error-message"></span><br> */}
        <div className="mb-3 row">
          <div className="col-sm-12 mb-3 text-center">
            <button
              type="submit"
              disabled={tutorformik.isSubmitting}
              className="login-btn fw-bold"
              style={{ color: "white !important" }}
            >
              {tutorformik.isSubmitting ? <HourglassLoader /> : "Register"}
            </button>
          </div>
        </div>
        <div className="log-undre-text text-center my-2">
          <p>
            Already a user?
            <Link to="/login">
              <span>Login</span>
            </Link>{" "}
          </p>
        </div>
      </form>
    </div>
  );
};

export default StudentRegister;
